<template>
    <div>
        <el-card class="box-card" v-if="showchart">
            <ve-line :data="lineData"></ve-line>
            <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      lineData: {
        columns: ['DATE', 'OD', 'OS', 'OU'],
        rows: []
      },
      showchart: false,
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.showchart = true
      this.apigetfuchalist2()
    },
    backCustomerManagement () {
      this.showchart = false
      this.$emit('triggerFunc', '')
    },
    apigetfuchalist2: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getfuchalist2, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.lineData.rows = []
            response.data.List.filter((item1, i1) => {
              that.lineData.rows.push({ DATE: item1.Inputtime, OD: item1.Nakedrighteyedegree, OS: item1.Nakedlefteyedegree, OU: item1.Nakedbinoculusdegree })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
